<template>
  <RawRecords v-if="showRawOutput" :records="records" />
  <table v-else-if="processedRecords.length !== 0">
    <colgroup>
      <col style="width: 15%;">
      <col style="width: 10%;">
      <col style="width: 15%;">
      <col style="width: 45%;">
      <col style="width: 15%;">
    </colgroup>
    <thead>
      <tr class="border-b-2 border-gray-200 text-left">
        <th scope="col" class="py-1.5 font-medium">Certificate usage</th>
        <th scope="col" class="py-1.5 font-medium">Selector</th>
        <th scope="col" class="py-1.5 font-medium">Matching type</th>
        <th scope="col" class="py-1.5 font-medium">Certificate association data</th>
        <th scope="col" class="py-1.5 font-medium">Revalidate in</th>
      </tr>
    </thead>
    <tbody>
      <tr v-for="(record, index) in processedRecords" :key="index" class="group">
        <td class="py-1">
          <span>{{ record.record.certificateUsage }}</span>
        </td>
        <td class="py-1">
          <span>{{ record.record.selector }}</span>
        </td>
        <td class="py-1">
          <span>{{ record.record.matchingType }}</span>
        </td>
        <td class="py-1">
          <span>{{ record.record.certificateAssociationData }}</span>
          <CnameChainBadge :chain="record.cnameChain" />
          <copy :content="record.record.certificateAssociationData" class="[visibility:hidden] group-hover:visible" />
        </td>
        <td class="py-1">
          <duration :seconds="record.record.ttl" />
        </td>
      </tr>
    </tbody>
  </table>
  <div v-else>No {{ recordType.plural }} found.</div>
</template>

<script setup lang="ts">
import { computed, PropType } from 'vue';
import { useStore } from 'vuex';
import Copy from '@/components/micro/CopyComponent.vue';
import Duration from '@/components/micro/DurationComponent.vue';
import RawRecords from '@/components/micro/RawRecords.vue';
import CnameChainBadge from '@/components/micro/CnameChainBadge.vue';
import { getRecordType } from '@/common/recordTypes';
import { QueryResult, RecordInfo, TLSA } from '@/model/Api';

const props = defineProps({
  records: {
    type: Object as PropType<QueryResult>,
    required: true,
  },
  domain: {
    type: String,
    required: true,
  },
});

type TlsaRecordWithInfo = {
  record: TLSA;
} & RecordInfo

const recordType = getRecordType('TLSA');

const store = useStore();
const showRawOutput = computed(() => store.state.showRawOutput);

const processedRecords = computed(() => {
  const processed: TlsaRecordWithInfo[] = props.records.response.answer.filter((item): item is TlsaRecordWithInfo => item.record.recordType === recordType.upper);
  return processed;
});
</script>
